module.exports = __webpack_public_path__ + "img/vnd.1b5abe91.png";